import dayjs from "dayjs";
import { useEffect, useState } from "react";
import {
  assertValidLanguage,
  useLanguage,
  useSetLanguage,
} from "../../../contexts/LanguageContext";

export function InfoBar() {
  const lang = useLanguage();
  const setLanguage = useSetLanguage();
  const [timeToShow, setTimeToShow] = useState(dayjs());

  useEffect(() => {
    const id = setInterval(() => setTimeToShow(dayjs()), 1000);
    return () => clearInterval(id);
  }, [setTimeToShow]);

  return (
    <div className="bg-primary text-white flex justify-end space-x-4 px-4 py-2">
      <p className="text-sm md:text-base text-inherit font-bold">
        {timeToShow.format("dddd, MMMM DD YYYY")}
      </p>
      <p className="text-sm md:text-base text-inherit font-bold">|</p>
      <p className="text-sm md:text-base text-inherit font-bold">
        {timeToShow.format("hh:mm:ss A")}
      </p>
      <p className="text-sm md:text-base text-inherit font-bold">|</p>
      <select
        className="text-black rounded px-2"
        value={lang}
        onChange={(e) => {
          const hit = e.target.value;
          if (assertValidLanguage(hit)) setLanguage(hit);
        }}
      >
        <option value="english">English</option>
        <option value="hindi">Hindi</option>
        <option value="marathi">Marathi</option>
      </select>
    </div>
  );
}
